import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=0f05e5d4&scoped=true&lang=pug&"
import script from "./Dashboard.vue?vue&type=script&lang=js&"
export * from "./Dashboard.vue?vue&type=script&lang=js&"
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=0f05e5d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f05e5d4",
  null
  
)

component.options.__file = "Dashboard.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VApp,
  VBtn,
  VContent,
  VIcon,
  VSpacer,
  VTooltip,
})
